<div class="content">
    <div class="intro">
        <p class="eyebrow" showdown [showDelay]="0">Our principles</p>
        <h2 showdown [showDelay]="80">The feeling we design for.</h2>
        <p showdown [showDelay]="160">A Veyora Fit piece should make movement feel quieter, dressing feel simpler, and
            confidence feel like something already in the room.</p>
    </div>

    <div class="principles">
        <div class="principle" showleft [showDelay]="40">
            <mat-icon fontSet="material-symbols-outlined">self_improvement</mat-icon>
            <span>01</span>
            <h3>Ease Before Intensity</h3>
            <p>Support should feel steady, breathable, and present without asking for attention.</p>
        </div>
        <div class="principle" showleft [showDelay]="120">
            <mat-icon fontSet="material-symbols-outlined">texture</mat-icon>
            <span>02</span>
            <h3>Texture Has Memory</h3>
            <p>We choose fabrics for the way they recover, drape, and stay soft through real wear.</p>
        </div>
        <div class="principle" showleft [showDelay]="200">
            <mat-icon fontSet="material-symbols-outlined">gesture</mat-icon>
            <span>03</span>
            <h3>Shape Follows Motion</h3>
            <p>Waistbands, straps, and seams are considered around bends, reaches, walks, and rest.</p>
        </div>
        <div class="principle" showleft [showDelay]="280">
            <mat-icon fontSet="material-symbols-outlined">wb_sunny</mat-icon>
            <span>04</span>
            <h3>Everyday Is The Test</h3>
            <p>Pieces should feel as natural after class as they do in the first minutes of movement.</p>
        </div>
    </div>
</div>
